<template lang="pug">
v-dialog(v-model="processInfoDialog" scrollable :fullscreen="$vuetify.breakpoint.xsOnly")
  wf-process-info-controller(v-show="processInfoDialog")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProcessInfoController from '@/components/process/ProcessInfoController'

export default {
  name: 'ProcessInfo',

  components: {
    'wf-process-info-controller': ProcessInfoController,
  },

  data() {
    return {
      model: false,
    }
  },

  computed: {
    ...mapGetters({
      processInfoDialog: 'process/processInfoDialog',
    }),
    processInfoDialog: {
      get() {
        return this.$store.getters['process/processInfoDialog']
      },
      set(value) {
        this.toggleProcessInfoDialog(value)
      },
    },
  },

  methods: {
    ...mapActions({
      selectInstance: 'process/selectInstance',
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
    }),
    show(processInstanceId) {
      this.selectInstance(processInstanceId).then(() => {
        this.toggleProcessInfoDialog(true)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/process/ProcessInfo.vue